module.exports = __webpack_public_path__ + "img/metropole-rouen-normandie.9dde205d.png";